import React, { createContext } from 'react';
export const ShopifyContext = createContext(null);
export const LocalizationContext = createContext(null);
export function ShopifyProviderClient({ children, shopifyConfig, localization, }) {
    if (!shopifyConfig) {
        throw new Error('The `shopifyConfig` prop should be passed to `ShopifyProvider`');
    }
    return (React.createElement(ShopifyContext.Provider, { value: shopifyConfig },
        React.createElement(LocalizationContext.Provider, { value: localization }, children)));
}
